export default __webpack_public_path__ + "static/wtu_2-99874ac5eb4bdf5d738bed9973b37da1.png";